import { createContext } from 'react'

const contextPayload = {
  regionInfo: {},
  userUnitsInfo: {}
}

const InitialConfigurationContext = createContext(contextPayload)
InitialConfigurationContext.displayName = 'initial-configuration'

export default InitialConfigurationContext
